import React, { useState, useEffect } from 'react'
import { Board, Info, Results, Rules } from '../../components/game'
import { notifications } from "../../utils/helpers";

import "./Console.css"

// Mock API call hook
import { Countries } from "../../hooks/useCountries"

let secret = Countries[Math.floor(Math.random() * Countries.length)].toLowerCase()

const Console = () => {

    const [start, restart] = useState(true);

    const [correctLetters, setCorrectLetters] = useState([]);
    const [wrongLetters, setWrongLetters] = useState([]);

    const [message, showMessage] = useState(false);

 
    useEffect(() => { 
        const handleKeydown = (event) => {
          const { key, keyCode } = event
          if (start && keyCode >= 65 && keyCode <= 90) {
            const letter = key.toLowerCase();
            if (secret.includes(letter)) {
              if (!correctLetters.includes(letter)) {
                setCorrectLetters((currentLetters) => [...currentLetters, letter]);
              } else {
                notifications(showMessage);
              }
            } else {
              if (!wrongLetters.includes(letter)) {
                setWrongLetters((currentLetters) => [...currentLetters, letter]);
              } else {
                notifications(showMessage);
              }
            }
          }
        };

        window.addEventListener("keydown", handleKeydown);
    
        return () => window.removeEventListener("keydown", handleKeydown);
    }, [correctLetters, wrongLetters, start]);
    
    const newGame = () => {
        restart(true);

        // Empty Arrays
        setCorrectLetters([]);
        setWrongLetters([]);

        secret = Countries[Math.floor(Math.random() * Countries.length)];        
    }

    return (
        <div style={{overflow: 'hidden !important'}}> 

          <div className="game-container">
            <Rules />
            <Board wrongLetters={wrongLetters} secret={secret} correctLetters={correctLetters}/>
          </div>
          
          <Results correctLetters={correctLetters} wrongLetters={wrongLetters} secret={secret} restart={restart} newGame={newGame} />
          
          {/* absolute element */}
          <Info show={message} />
        </div>
    )
}

export default Console
